import { FC } from 'react';
import { OnboardingFileUpload } from '../OnboardingFileUpload/OnboardingFileUpload';

export const IdentityVerificationStep: FC = () => {
  return (
    <div className="flex flex-col gap-4 lg:gap-8 items-stretch justify-center text-center">
      <OnboardingFileUpload label="Primary ID" index={1} />
      <OnboardingFileUpload label="Secondary ID (Optional)" index={2} />
    </div>
  );
};
